import Company from './Models/Company'

Vue.prototype.$models.$company = new Vue(Company)

Vue.component('companies-table', () => import(/* webpackChunkName: "companies-table" */ '@modulesPages/Site/Resources/assets/js/Tables/CompaniesTable'))
Vue.component('speakers-table', () => import(/* webpackChunkName: "speakers-table" */ '@modulesPages/Site/Resources/assets/js/Tables/SpeakersTable'))
Vue.component('subscribers-table', () => import(/* webpackChunkName: "subscribers-table" */ '@modulesPages/Site/Resources/assets/js/Tables/SubscribersTable'))

Vue.component('companies-form', () => import(/* webpackChunkName: "companies-form" */ '@modulesPages/Site/Resources/assets/js/Forms/Companies/CompaniesForm'))

Vue.component('companies-card', () => import(/* webpackChunkName: "companies-card" */ '@modulesPages/Site/Resources/assets/js/Cards/CompaniesCard'))

Vue.component('translate-component', () => import(/* webpackChunkName: "translate-component" */ '@modulesPages/Site/Resources/assets/js/Components/TranslateComponent'))
Vue.component('banner-simple', () => import(/* webpackChunkName: "banner-simple" */ '@modulesPages/Site/Resources/assets/js/Components/BannerSimple'))
Vue.component('go-create-company-button', () => import(/* webpackChunkName: "go-create-company-button" */ '@modulesPages/Site/Resources/assets/js/Components/GoCreateCompanyButton'))


app.$Util.formattedClassName = {
    ...app.$Util.formattedClassName,
    ...{
        'Modules\\Site\\Entities\\Company': 'Empresa',
    }   
}
